import setupBaseController from '../setup.base.controller';

class PrefixTableController extends setupBaseController{
  /*@ngInject*/
 
  constructor(Auth, $state, User, SetupService, Modal, $translate, $stateParams, $scope) {
    super(Auth, $state, User, SetupService, Modal, $translate, $stateParams, $scope);
    this.avaialablePrefixes = [
      { value: 'messenger', label: 'Messenger' },
      { value: 'route', label: 'Route' },
      { value: 'bagout', label: 'Bagout' },
      { value: 'employee', label: 'Employee' },
      { value: 'location', label: 'Location' },
      { value: 'tanker', label: 'Tanker' },
      { value: 'vehicle', label: 'Vehicle' },
      { value: 'branch', label: 'Branch' },
      { value: 'window', label: 'Window' },
      { value: 'deliveryAndPickups', label: 'Delivery And Pickups' }
    ];
    this.model = [];
    this.$scope = $scope;
    this.prefixes = this.prefixes || {};
  }
  
  $onInit() {
    this.$scope.$watch(() => {
      return this.prefixes && JSON.stringify(this.prefixes);
    }, (newValue, oldValue) => {
      if (this.pullModel) {
        this.pullModel();
      }
    });

    this.$scope.$watch(() => {
      return JSON.stringify(this.model);
    }, (newValue, oldValue) => {
      if (!!this.model) {
        this.pushModel();
      }
    });
  }

  pullModel() {
    for (let prefixType in this.prefixes) {
      const prefixArray = this.prefixes[prefixType];

      prefixArray.forEach((prefixChar) => {
        this.model.push({
          type: prefixType,
          value: prefixChar
        });
      });
    }
  }

  pushModel() {
    const newPrefix = {};

    this.model.forEach(({ type, value }) => {
      if (newPrefix[type]) {
        newPrefix[type].push(value);
      }
      else {
        newPrefix[type] = [value];
      }
    });

    this.modelValue = newPrefix;
  }

  addNewPrefix() {
    this.model.push({
      type: null,
      value: ''
    });
  }
  
  removePrefix(index) {
    this.model.splice(index, 1);
  }

  // deletePrefixes(index) {
  //   console.log("555");
  //   this.Modal.confirm({
  //     header: this.$translate.instant('common.confirm_delete_title'),
  //     message: this.$translate.instant('common.confirm_delete_message'),
  //     callback: ({
	// 			modal,
  //       $scope
	// 		}) => {
	// 				this.model.splice(index, 1);
	// 				modal.close()					
	// 		},
  //     negative: ({
	// 			modal,
  //       $scope
	// 		}) => {
  //       modal.close()
  //     },
  //     type: 'primary',
  //     buttons: ['common.yes', 'common.no']
  //   })
  // }

}

export default PrefixTableController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/setup/common/prefix-table/prefix-table.controller.js